import React, {useEffect, useState} from 'react';
import {Chip} from '@mui/material';
import {Typography} from '@fupa/fupa-uikit';
import {useHistory} from 'react-router';
import {clearPartner} from 'app/actions/partnerActions';
import {useDispatch} from 'react-redux';
import {LastItems, LastItemsWrapper} from 'app/styles/lastItemsStyles';
import {getElementFromLocalStorage} from 'app/helpers/webStorageUtility';
import styled from 'styled-components';

const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
`;

export const LastDistricts = ({selectedDistrict}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [lastDistricts, setLastDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const lastDistrictsFromStorage = getElementFromLocalStorage('last-districts');
    setLastDistricts(JSON.parse(lastDistrictsFromStorage));
    setIsLoading(false);
  }, []);

  const handleClick = slug => {
    dispatch(clearPartner());
    history.push(`/region/${slug}`);
  };

  let content;
  if (lastDistricts && lastDistricts.length > 1) {
    content = lastDistricts.map(district => {
      const {slug, name} = district;
      if (slug !== selectedDistrict.slug) {
        return <Chip key={`lastvisited-${slug}`} label={name} variant='outlined' onClick={() => handleClick(slug)} />;
      } else {
        return null;
      }
    });
  } else if (isLoading) {
    content = <Placeholder variant='body1'> </Placeholder>;
  } else {
    const label = 'Noch keine zuletzt besuchten Regionen';
    content = (
      <Placeholder>
        <Chip style={{borderStyle: 'dashed'}} label={label} variant='outlined' disabled={true} />
      </Placeholder>
    );
  }

  return (
    <LastItemsWrapper>
      <Typography variant='caption1'>Zuletzt besuchte Regionen</Typography>
      <LastItems>{content}</LastItems>
    </LastItemsWrapper>
  );
};
